import { jsonBlob } from './jsonBlob';

export async function downloadJson(data: unknown, filename: string): Promise<void> {
  const blob = await jsonBlob(data, { pretty: false });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/** Generic JSON chip bundles; project import uses projectFileIO's current-format boundary. */
export function readJsonFile<T>(file: File): Promise<T> {
  if (file.size < 1024 * 1024 || typeof Worker === 'undefined')
    return file.text().then((text) => JSON.parse(text) as T);
  return new Promise<T>((resolve, reject) => {
    const worker = new Worker(new URL('./readJson.worker.ts', import.meta.url), {
      type: 'module',
    });
    worker.onerror = () => {
      worker.terminate();
      reject(new Error('Unable to read JSON file.'));
    };
    worker.onmessage = (event: MessageEvent<{ value?: T; error?: string }>) => {
      worker.terminate();
      if (event.data.error) reject(new Error(event.data.error));
      else resolve(event.data.value as T);
    };
    worker.postMessage({ file });
  });
}

export function pickAndReadJsonFile<T>(): Promise<T | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json,application/json';

    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) {
        resolve(null);
        return;
      }
      try {
        resolve(await readJsonFile<T>(file));
      } catch {
        resolve(null);
      }
    };

    // If the user cancels the picker, resolve null
    input.oncancel = () => resolve(null);

    input.click();
  });
}
